import * as yup from 'yup';

export const VALIDATION_EDIT_OBJECT = {
  name: yup.string().required('Obbligatorio'),
  surname: yup.string().required('Obbligatorio'),
  email: yup.string().required('Obbligatorio'),
};
